import { render, staticRenderFns } from "./pageEdit.vue?vue&type=template&id=e38ac2fc&scoped=true&"
import script from "./pageEdit.vue?vue&type=script&lang=js&"
export * from "./pageEdit.vue?vue&type=script&lang=js&"
import style0 from "./pageEdit.vue?vue&type=style&index=0&id=e38ac2fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38ac2fc",
  null
  
)

export default component.exports